import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useHouseholdId } from '@/shared/hooks'

export function useMealPlanRealtime() {
  const queryClient = useQueryClient()
  const { householdId } = useHouseholdId()

  useEffect(() => {
    if (!householdId) return

    // meal_plan_slots has no direct household_id column — omit filter.
    // RLS protects the subsequent invalidateQueries refetch.
    const channel = supabase
      .channel(`meal-plan-${householdId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'meal_plan_slots',
        },
        () => {
          // Partial key invalidates all ['meal-plan', <weekStartDate>] entries
          queryClient.invalidateQueries({ queryKey: ['meal-plan'] })
        },
      )
      .subscribe()

    return () => {
      supabase.removeChannel(channel)
    }
  }, [householdId, queryClient])
}
